export const extractErrorMessage = (error) => {
  if (error.response) {
    if (error.response.data.message) return error.response.data.message
    else if (error.response.data.errors)
      return error.response.data.errors.map((e) => e.msg).join(', \n')
  }

  if (error.request) return error.request

  return error.message
}
